import Home from './views/home';
import About from './views/about';
import Collections from './views/collections';
import CollectionSinglePage from './views/collectionSinglePage';
import Blogs from './views/blog';
import BlogSinglePage from './views/blogSinglePage';
import Terms from './views/terms';
import FAQ from './views/faq';
import Privacy from './views/privacy';

const routes = [    
    {
        path: "/fr",
        component: Home
    },
    {
        path: "/",
        component: Home
    },
    {
        path: "/fr/about",
        component: About
    },
    {
        path: "/about",
        component: About
    },
    {
        path: "/fr/collections/:id",
        component: CollectionSinglePage
    },
    {
        path: "/collections/:id",
        component: CollectionSinglePage
    },
    {
        path: "/fr/collections",
        component: Collections
    },
    {
        path: "/collections",
        component: Collections
    },
    {
        path: "/fr/blog/:id",
        component: BlogSinglePage
    },
    {
        path: "/blog/:id",
        component: BlogSinglePage
    },
    {
        path: "/fr/blog",
        component: Blogs
    },
    {
        path: "/blog",
        component: Blogs
    },
    {
        path: "/fr/terms",
        component: Terms
    },
    {
        path: "/terms",
        component: Terms
    },
    {
        path: "/fr/faq",
        component: FAQ
    },
    {
        path: "/faq",
        component: FAQ
    },
    {
        path: "/fr/policy",
        component: Privacy
    },
    {
        path: "/policy",
        component: Privacy
    },
]


export default routes;